export default "__VITE_ASSET__DDhGMHVV__"